import React from "react";
import { Typography } from "@mui/material";
import "./Achievment.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import "animate.css/animate.min.css";
function Achievment() {
  return (
    <div>
      <Typography
        variant="h4"
        color={"#fff"}
        align="center"
        sx={{ margin: "50px" }}>
        My Achievments
      </Typography>

      <div className="row">
        <div
          data-vc-full-width="true"
          data-vc-full-width-init="true"
          className="achievment-details vc_row wpb_row vc_row-fluid vc_custom_1542873226451 vc_row-has-fill wgl-row-animation"
          style={{}}>
          <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-offset-3 vc_col-lg-6 vc_col-md-offset-2 vc_col-md-8">
            <div className="vc_column-inner ">
              <div className="wpb_wrapper">
                <div
                  id="seofy_spacer_5cf90ca8186e1"
                  className="seofy_module_spacing responsive_active">
                  <div
                    className="spacing_size spacing_size-initial"
                    style={{ height: "53px" }}></div>
                  <div
                    className="spacing_size spacing_size-tablet"
                    style={{ height: "30px" }}></div>
                </div>
                <div
                  id="seofy_dbl_5cf90ca818809"
                  className="seofy_module_double_headings acenter ">
                  <div
                    className="heading_title"
                    style={{
                      fontSize: "36px",
                      lineHeight: "1.333",
                      fontWeight: "800",
                    }}>
                    <span className="heading_divider"></span>
                  </div>
                </div>
                <div className="seofy_module_spacing">
                  <div
                    className="spacing_size spacing_size-initial"
                    style={{ height: "10px" }}></div>
                </div>
              </div>
            </div>
          </div>
          <div className="wpb_column vc_column_container vc_col-sm-12">
            <div className="vc_column-inner ">
              <div className="wpb_wrapper">
                <div className="seofy_module_spacing">
                  <div
                    className="spacing_size spacing_size-initial"
                    style={{ height: "30px" }}></div>
                </div>
                <div className="seofy_module_time_line_vertical appear_anim">
                  <div
                    id="time_line_5cf90ca818f641"
                    className="time_line-item  item_show">
                    <div className="time_line-date_wrap">
                      <div className="seofy_hexagon">
                        <svg
                          style={{ fill: "#ffa705" }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <div className="seofy_hexagon">
                        <svg
                          style={{
                            filter:
                              "drop-shadow(4px 5px 4px rgba(255,167,5,0.3))",
                            fill: "#ffa705",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <h4 className="time_line-date">( 1 )</h4>
                    </div>
                    <AnimationOnScroll
                      animateIn="animate__fadeInLeftBig"
                      animatePreScroll>
                      <div className="time_line-content">
                        <h5 className="time_line-title">
                          TCS Codevita Session 10
                        </h5>
                        <div className="time_line-descr">
                          👉 Secured 470th global rank in round-2 among 1.5Lac
                          students.
                        </div>
                      </div>
                    </AnimationOnScroll>
                  </div>
                  <div
                    id="time_line_5cf90ca818fe44"
                    className="time_line-item  item_show">
                    <div className="time_line-date_wrap">
                      <div className="seofy_hexagon">
                        <svg
                          style={{ fill: "#12affe" }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <div className="seofy_hexagon">
                        <svg
                          style={{
                            filter:
                              "drop-shadow(4px 5px 4px rgba(18,175,254,0.3))",
                            fill: "#12affe",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <h4 className="time_line-date">( 2 )</h4>
                    </div>
                    <AnimationOnScroll
                      animateIn="animate__fadeInLeftBig"
                      animatePreScroll>
                      <div className="time_line-content">
                        <h5 className="time_line-title">HackerRank</h5>
                        <div className="time_line-descr">
                          👉 5-star in JAVA and C++ & DSA.<br></br> 👉 Cirtified
                          in DSA basics and Intermediate
                        </div>
                      </div>
                    </AnimationOnScroll>
                  </div>
                  <div
                    id="time_line_5cf90ca818f641"
                    className="time_line-item  item_show">
                    <div className="time_line-date_wrap">
                      <div className="seofy_hexagon">
                        <svg
                          style={{ fill: "#ffa705" }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <div className="seofy_hexagon">
                        <svg
                          style={{
                            filter:
                              "drop-shadow(4px 5px 4px rgba(255,167,5,0.3))",
                            fill: "#ffa705",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <h4 className="time_line-date">( 3 )</h4>
                    </div>
                    <AnimationOnScroll
                      animateIn="animate__fadeInLeftBig"
                      animatePreScroll>
                      <div className="time_line-content">
                        <h5 className="time_line-title">CodeChef</h5>
                        <div className="time_line-descr">
                          👉 3 star @CodeChef with Highest Rating 1764 <br></br>
                          👉 Secured global rank 7 in CodeChef March Lunchtime
                          2022 ( Div 3 )
                        </div>
                      </div>
                    </AnimationOnScroll>
                  </div>
                  <div
                    id="time_line_5cf90ca818fe44"
                    className="time_line-item  item_show">
                    <div className="time_line-date_wrap">
                      <div className="seofy_hexagon">
                        <svg
                          style={{ fill: "#12affe" }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <div className="seofy_hexagon">
                        <svg
                          style={{
                            filter:
                              "drop-shadow(4px 5px 4px rgba(18,175,254,0.3))",
                            fill: "#12affe",
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 177.4 197.4">
                          <path d="M0,58.4v79.9c0,6.5,3.5,12.6,9.2,15.8l70.5,40.2c5.6,3.2,12.4,3.2,18,0l70.5-40.2c5.7-3.2,9.2-9.3,9.2-15.8V58.4 c0-6.5-3.5-12.6-9.2-15.8L97.7,2.4c-5.6-3.2-12.4-3.2-18,0L9.2,42.5C3.5,45.8,0,51.8,0,58.4z"></path>
                        </svg>
                      </div>
                      <h4 className="time_line-date">( 4 )</h4>
                    </div>
                    <AnimationOnScroll
                      animateIn="animate__fadeInLeftBig"
                      animatePreScroll>
                      <div className="time_line-content">
                        <h5 className="time_line-title">
                          Google kickstart 2021
                        </h5>
                        <div className="time_line-descr">
                          👉 Secured 2777th global Rank in google kickstart 2021
                        </div>
                      </div>
                    </AnimationOnScroll>
                  </div>
                </div>
                <div
                  id="seofy_spacer_5cf90ca8190c4"
                  className="seofy_module_spacing responsive_active">
                  <div
                    className="spacing_size spacing_size-initial"
                    style={{ height: "76px" }}></div>
                  <div
                    className="spacing_size spacing_size-tablet"
                    style={{ height: "65px" }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Achievment;
